import React, { Component } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

class DeleteModal extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.showSweetAlert();
    }
  }

  showSweetAlert = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.onDeleteClick();
      } else {
        this.props.onCloseClick();
      }
    });
  };

  render() {
    return null;
  }
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.bool.isRequired,
};

export default DeleteModal;
